module.exports = __webpack_public_path__ + "img/attitude_club.7a0d6d35.jpg";